(function pollForElement() {
    var targetNodeSelector = '.free_shipping_card_title_clnlu8nwr15623518trou671ny4';
    var hideSelectors = ['.free_shipping_card_progress_clnlu8nwr15623518trou671ny4', '.essential_product_slider_glide'];

    function updateElementVisibility() {
        var targetNode = document.querySelector(targetNodeSelector);
        if (targetNode) {
            // Determine the display style based on the text content
            var displayStyle = targetNode.textContent.includes("You've got free shipping") ? 'none' : '';
            
            // Apply the determined display style to each selector
            hideSelectors.forEach(function(selector) {
                document.querySelectorAll(selector).forEach(function(element) {
                    element.style.display = displayStyle;
                });
            });
        }
    }

    function setupObserver() {
        var targetNode = document.querySelector(targetNodeSelector);
        if (targetNode) {
            // The observer will call updateElementVisibility when mutations are observed
            var observer = new MutationObserver(updateElementVisibility);
            observer.observe(targetNode, { childList: true, characterData: true, subtree: true });
        } else {
            // If the target node doesn't exist yet, wait a bit and then try again
            setTimeout(setupObserver, 500);
        }
    }

    updateElementVisibility(); // Check and update visibility initially
    setupObserver(); // Start the observer to monitor for changes
})();
